/** Adjusts markdown for the mid-generation render only, leaving the document itself untouched. */

/** An image on a line of its own, either markdown (`![alt](url)`) or an HTML `<img>` tag. */
const STANDALONE_IMAGE_LINE = /^[ \t]*(?:!\[[^\]]*\]\([^)]*\)|<img\b[^>]*>)[ \t]*$\n?/gim

/**
 * Drops standalone images while a deliverable is streaming, per ADR 0004.
 * @param markdown The accumulated markdown about to be rendered.
 * @returns The same markdown with standalone image lines removed.
 */
export const stripImagesForStreamedRender = (markdown: string): string => {
   return markdown.replace(STANDALONE_IMAGE_LINE, '')
}
